import { useRef, useEffect } from 'react';
import { useRefFn } from '@axios-use/react';

import type { ProductExtraInfo } from '../../external/trackinfo';
import { parseProductExtraInfo } from '../../external/trackinfo';

export type ProductObserverOptionsType = {
  wrapperScrollEl?: HTMLDivElement | null;
  callback?: (info?: ProductExtraInfo) => void;
};

const canIUseIntersectionObserver = typeof window !== 'undefined' && typeof window.IntersectionObserver !== 'undefined';

export function useProductObserver(options?: ProductObserverOptionsType) {
  const { wrapperScrollEl, callback } = options || {};

  const callbackRef = useRefFn(callback);

  const register = useRef(false);
  useEffect(() => {
    if (wrapperScrollEl && !register.current) {
      if (canIUseIntersectionObserver) {
        register.current = true;

        const observer = new IntersectionObserver(
          (e, o) => {
            e.forEach((entry) => {
              if (entry.isIntersecting) {
                const _infoitem = entry.target.attributes.getNamedItem('data-info');
                if (_infoitem) {
                  const _str = _infoitem.nodeValue || _infoitem.value;
                  const _obj = parseProductExtraInfo(_str);
                  if (_obj) {
                    console.info('product observer. code: %s, name: %s', _obj._code, _obj._name);
                    callbackRef.current?.(_obj);
                  }
                }
                o.unobserve(entry.target);
              }
            });
          },
          {
            root: wrapperScrollEl,
            threshold: 1,
            rootMargin: '0px 0px -70px 0px',
          },
        );

        const targets = document.querySelectorAll("div[id^='product-code']");
        if (targets) {
          targets.forEach((el) => {
            observer.observe(el);
          });
        }
      } else {
        console.warn('[useProductObserver] IntersectionObserver API is not supported');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperScrollEl]);
}
